// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MA32k","location":"Header_location__JXRPu"};